angular.module('dat.shared-components.common')
	.factory('eventNameService', [
		function() {
			'use strict';

			return {
				rateCalculator: {
					PreferencesUpdated: 'RATE_CALCULATOR_PREFERENCES_UPDATED'
				},
				modalDialog: {
					closed: 'MODAL_DIALOG_CLOSED'
				},
				toolTip: {
					reposition: 'TOOLTIP_REPOSITION'
				},
				tabs: {
					selected: 'TABS_SELECTED'
				},
				companyDetail: {
					modalClosed: 'dat:company-detail:modal-closed',
					addedOfficeFilter: 'dat:company-detail:added-office-filter',
					removedOfficeFilter: 'dat:company-detail:removed-office-filter'
				},
				equipmentSelect: {
					equipmentParsed: 'dat:equipment-select:equipment-parsed',
					emptySearchInitialized: 'dat:equipment-select:empty-search-initialized',
					closeAndOpen: 'dat:equipment-select:close-and-open'
				},
				sessionLogin: {
					loginSuccessful: 'dat:session-login:login-successful',
					loginFailed: 'dat:session-login:login-failed'
				},
				slider: {
					newValue: 'dat.slider:new-value'
				},
				tabbedModalDialog: {
					openTab: 'TABBED_MODAL_DIALOG.OPEN_TAB',
					validationStateChanged: 'TABBED_MODAL_DIALOG.VALIDATION_STATE_CHANGED',
					changeView: 'TABBED_MODAL_DIALOG.NAVIGATION',
					openModal: 'TABBED_MODAL_DIALOG.DATA_OPEN',
					closeModal: 'TABBED_MODAL_DIALOG.CLOSE',
					forceCloseModal: 'TABBED_MODAL_DIALOG.FORCE_CLOSE'
				}
			};
		}
	]);
